import { render, staticRenderFns } from "./TicketIcon.vue?vue&type=template&id=67776de9&scoped=true"
var script = {}
import style0 from "./TicketIcon.vue?vue&type=style&index=0&id=67776de9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67776de9",
  null
  
)

export default component.exports